export default __webpack_public_path__ + "static/media/saude_um.c8fae46f.jpg";